import { render, staticRenderFns } from "./abnormal_training_detail.vue?vue&type=template&id=0cbe422e&"
import script from "./abnormal_training_detail.vue?vue&type=script&lang=js&"
export * from "./abnormal_training_detail.vue?vue&type=script&lang=js&"
import style0 from "./abnormal_training_detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports